import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {AnimalType, Paddock} from 'src/app/infrastructure/moovement-api/models/asset';
import {AddWeightMeasurementRequest} from 'src/app/infrastructure/moovement-api/web-api/animal.api-client';

interface AddAnimalState {
  name: string | undefined;
  animalType: AnimalType | undefined;
  paddock: Paddock | undefined;
  year: number | undefined;
  weightMeasurement: AddWeightMeasurementRequest | undefined;
  comment: string | undefined;
  profilePictureUrl: string | undefined;
}

const initialState: AddAnimalState = {
  name: undefined,
  animalType: undefined,
  paddock: undefined,
  year: undefined,
  weightMeasurement: undefined,
  comment: undefined,
  profilePictureUrl: undefined
};

export const AddAnimalStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setName(name?: string) {
      patchState(store, {name})
    },
    setAnimalType(animalType: AnimalType) {
      patchState(store, {animalType})
    },
    setYear(year: number) {
      patchState(store, {year})
    },
    setPaddock(paddock: Paddock) {
      patchState(store, {paddock})
    },
    setWeightMeasurement(weightMeasurement?: AddWeightMeasurementRequest) {
      patchState(store, {weightMeasurement})
    },
    setComment(comment?: string) {
      patchState(store, {comment})
    },
    setProfilePictureUrl(profilePictureUrl: string | undefined) {
      patchState(store, {profilePictureUrl});
    },
    reset() {
      patchState(store, {
        name: undefined,
        weightMeasurement: undefined,
        comment: undefined,
        profilePictureUrl: undefined
      });
    }
  })
));
